import {
  handleExpiredTokens,
  transformerConfigFactory,
} from 'api/apiReqSagaCreator/httpRequest';
import {
  ApiResponseAsync,
  translateAxiosErrorToApiError,
} from 'container/models';

import { AbstractBareClientRepo } from './abstractBareClientRepo';
import { IBareClientRepo } from './IBareClientRepo';

export class BareClientRepo
  extends AbstractBareClientRepo
  implements IBareClientRepo
{
  get<Response>(
    url: string,
    opts?: { responseTransformerStopPaths?: string[] }
  ) {
    return handleExpiredTokens(() =>
      this.client.get<Response>(url, {
        ...transformerConfigFactory({
          responseStopPaths: opts?.responseTransformerStopPaths,
        }),
      })
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
  }

  getBlob(url: string): ApiResponseAsync<Blob> {
    return handleExpiredTokens(() =>
      this.client.get<Blob>(url, {
        responseType: 'blob',
      })
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
  }

  patch<Payload, Response>(
    url: string,
    data: Payload,
    opts?: {
      requestTransformerStopPaths?: string[];
      responseTransformerStopPaths?: string[];
    }
  ) {
    return handleExpiredTokens(() =>
      this.client.patch<Response>(url, data, {
        ...transformerConfigFactory({
          requestStopPaths: opts?.requestTransformerStopPaths,
          responseStopPaths: opts?.responseTransformerStopPaths,
        }),
      })
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
  }

  delete<Response>(
    url: string,
    opts?: {
      responseTransformerStopPaths?: string[];
    }
  ) {
    return handleExpiredTokens(() =>
      this.client.delete<Response>(url, {
        ...transformerConfigFactory({
          responseStopPaths: opts?.responseTransformerStopPaths,
        }),
      })
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
  }

  post<Payload, Response>(
    url: string,
    data: Payload,
    opts?: {
      requestTransformerStopPaths?: string[];
      responseTransformerStopPaths?: string[];
    }
  ): ApiResponseAsync<Response> {
    return handleExpiredTokens(() =>
      this.client.post<Response>(url, data, {
        ...transformerConfigFactory({
          requestStopPaths: opts?.requestTransformerStopPaths,
          responseStopPaths: opts?.responseTransformerStopPaths,
        }),
      })
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
  }

  put<Payload, Response>(
    url: string,
    data: Payload,
    opts?: {
      requestTransformerStopPaths?: string[];
      responseTransformerStopPaths?: string[];
    }
  ): ApiResponseAsync<Response> {
    return handleExpiredTokens(() =>
      this.client.put<Response>(url, data, {
        ...transformerConfigFactory({
          requestStopPaths: opts?.requestTransformerStopPaths,
          responseStopPaths: opts?.responseTransformerStopPaths,
        }),
      })
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
  }
}
